import {
  FilesUploadInput,
  type FileUploaderInputProps,
} from "./FilesUploadInput";
import { useFilesUploader } from "./useFilesUploader";
import { type FilesUploader } from "../core";

interface DropzoneProps {
  title: string;
  style?: React.CSSProperties;
  className?: string;
}

export interface FilesUploadDropzoneProps {
  dropzoneProps: DropzoneProps;
  inputProps: FileUploaderInputProps;
  uploader: InstanceType<typeof FilesUploader>;
}

export const FilesUploadDropzone = ({
  dropzoneProps,
  inputProps,
  uploader,
}: FilesUploadDropzoneProps) => {
  const { handleInputChange, handleDrop, inputRef, allowedFileExtensions } =
    useFilesUploader({
      uploader,
    });

  const { title, style, className } = dropzoneProps;

  return (
    <div
      id="direct_upload"
      onDrop={handleDrop}
      onDragOver={(event) => event.preventDefault()}
      style={{
        ...(style && { ...style }),
      }}
      className={className}
    >
      {title}
      <FilesUploadInput
        {...inputProps}
        ref={inputRef}
        onChange={handleInputChange}
        accept={allowedFileExtensions}
      />
    </div>
  );
};
